﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function expandableListContainerBlockExpand(context) {
  const itemsToShow = context.getAttribute('data-items') && Number(context.getAttribute('data-items'));
  const listItems = context.querySelectorAll('.expandable-list-item__heading');
  const expandButton = context.querySelector('.expandable-list__button');
  let isExpanded = false;

  function init() {
    if (!expandButton) return
    loopItems();

    expandButton.addEventListener('click', function () {
      isExpanded = !isExpanded;
      context.classList.toggle('expandable-list--showall');
      loopItems();
    });
  }

	function loopItems() {
    for (let i = 0; i < listItems.length; i++) {
      const singleListItem = listItems[i];
      const singleListItemExpandButton = singleListItem.querySelector('.expandable-list-item__heading__expand');

      if ((i + 1) > itemsToShow && !isExpanded)
        singleListItemExpandButton.setAttribute('disabled', 'disabled');
      else if (isExpanded)
        singleListItemExpandButton.removeAttribute('disabled');
    }
	}

  return {
    init
  };
}

controller.add('expandable-list-block-expand', expandableListContainerBlockExpand);